import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    event_option:""
}

const eventEditSlice = createSlice({
    name:"event-edit",
    initialState,

    reducers:{
        eventEditOption:(state, {payload}) => {
            state.event_option = payload
        }
    }
})

export const {
    eventEditOption
} = eventEditSlice.actions
export default eventEditSlice.reducer